import classNames from "classnames";
import { CheckboxBase } from "../../../inputs";
import { TableColumnDef } from "../../types";

import styles from "./styles.module.scss";

export const SelectionColumnId = "___selection_column";

export function SelectionColumn<T extends object = {}>({ minimized, ...params }: TableColumnDef<T> & { minimized?: boolean }): TableColumnDef<T> {
  return {
    id: SelectionColumnId,
    enableColumnFilter: true,
    minSize: minimized ? 44 : 64,
    size: minimized ? 44 : 64,
    enableResizing: false,
    enableSorting: false,
    header: ({ table }) => (
      <CheckboxBase
        checkboxBaseSize={"sm"}
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={(value, event) => {
          if ((event.nativeEvent as PointerEvent).shiftKey) {
            table.toggleAllPageRowsSelected(!table.getIsAllPageRowsSelected());
          } else {
            table.toggleAllRowsSelected(value);
          }
        }}
        //todo IsFetching
        // disabled={true}
      />
    ),
    cell: ({ row }) => (
      <CheckboxBase
        checkboxBaseSize={"sm"}
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        onChange={(value, e) => row.getToggleSelectedHandler()(e)}
      />
    ),
    ...params,
    meta: {
      hideInSettings: true,
      getHeaderProps: cell => ({
        hideTooltip: true,
        className: classNames(styles.headerCell, { [styles.minimized]: minimized }),
        textClassname: styles.text,
      }),
      getCellProps: cell => ({
        className: classNames(styles.tableCell, { [styles.minimized]: minimized }),
      }),
      ...params.meta,
    },
  };
}
